export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=70ab2243940ab9590cb2ee134cb1c165dd65d9f738&name=pushAdClickData!'